var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetMarketGraphIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 150,
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5322 64.2568C28.6329 62.6847 30.8218 62.3533 32.3779 63.5059L46.3281 73.8389C47.8781 74.9868 48.2098 77.182 47.1006 78.7852C33.3997 98.5815 25.6988 121.914 24.9248 145.977C24.8621 147.925 23.2893 149.492 21.3604 149.492L4 149.491C2.0635 149.491 0.502422 147.922 0.553711 146.004C1.33717 116.7 10.7195 88.2702 27.5322 64.2568Z",
    fill: "url(#paint0_linear_447_9584)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.903 8.11133C104.724 7.50692 106.678 8.54791 107.239 10.4014L112.266 27.0176C112.825 28.8638 111.78 30.823 109.933 31.4473C87.0431 39.1832 66.8791 53.3832 51.8824 72.3281C50.6723 73.8568 48.4754 74.1803 46.9254 73.0322L32.9752 62.6992C31.4191 61.5466 31.098 59.3569 32.2809 57.8457C50.4144 34.681 74.9828 17.3787 102.903 8.11133Z",
    fill: "#F08C00",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.537 5.80273C138.912 -1.96317 168.952 -1.18443 196.886 8.04199C198.708 8.64387 199.654 10.6448 198.998 12.4668L193.116 28.7998C192.463 30.6146 190.455 31.5643 188.601 30.9629C165.616 23.5095 140.962 22.8701 117.622 29.1221C115.739 29.6262 113.783 28.5745 113.225 26.7285L108.197 10.1113C107.637 8.25789 108.686 6.30932 110.537 5.80273Z",
    fill: "#F0E400",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.947 12.8076C200.604 10.9859 202.608 10.0481 204.396 10.7461C231.796 21.449 255.433 40.0008 272.34 64.0732C273.443 65.6436 273.008 67.8134 271.395 68.8838L256.927 78.4795C255.319 79.5456 253.143 79.1096 252.014 77.5205C238.02 57.8246 218.621 42.5981 196.164 33.6855C194.352 32.9663 193.411 30.9553 194.064 29.1406L199.947 12.8076Z",
    fill: "#A6CD52",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.966 69.7451C273.58 68.6753 275.747 69.1199 276.765 70.7471C290.814 93.219 298.639 119.024 299.434 145.515C299.491 147.433 297.935 149.006 295.998 149.013L278.638 149.071C276.709 149.078 275.131 147.516 275.062 145.567C274.292 123.857 267.884 102.719 256.468 84.2373C255.443 82.5786 255.888 80.4037 257.496 79.3379L271.966 69.7451Z",
    fill: "url(#paint1_linear_447_9584)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_9584",
    x1: 24.9202,
    y1: 60.7236,
    x2: 24.9202,
    y2: 149.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_447_9584",
    x1: 276.943,
    y1: 67.1182,
    x2: 276.943,
    y2: 149.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BBB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetMarketGraphIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_market_graph_icon.5c1c6be03bda218adeaa65fb9359502f.svg";
export { ForwardRef as ReactComponent };